export interface RequestParameters {
  id?: string
  data?: any
  params?: any
  force?: boolean
  onSuccess?: (res: any) => void
  onError?: (err: any) => void
  onFinal?: () => void
  // Allow any additional parameters for URL substitution
  [key: string]: any
}

export interface HookResult<T = any, E = any> {
  data: T
  loading: boolean
  success: boolean
  error: E
  errorData: any
  execute: (parameters?: RequestParameters) => void
}

export function createDefaultHookResult(): HookResult {
  return {
    data: null,
    loading: false,
    success: false,
    error: null,
    errorData: null,
    execute: (parameters?: RequestParameters) => {},
  }
}
